"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var withStyles_1 = require("../../../common/utils/withStyles");
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.tooltip },
        children,
        react_1.default.createElement("span", { className: styles_scss_1.default.content, "aria-hidden": "true" }, content)));
};
exports.default = withStyles_1.withStyles(styles_scss_1.default)(Tooltip);
//# sourceMappingURL=tooltip.js.map